import View from '../../../../View'
import PanelContainer from '../../../../components/PanelContainer'

export default class HierarchyAssignmentsEditorPanel extends View {
    constructor({
        hierarchyAssignmentsEditor,
        extraClass = '',
        panelType = '',
        closeEditor = () => {},
        onClickContent = e => {},
        closeAllPanels = () => {},
    }) {
        super()

        this.params = {
            hierarchyAssignmentsEditor,
            extraClass,
            panelType,
            onClickContent
        }

        this.actions = {
            closeEditor,
            closeAllPanels
        }

        this.state = {
            show: false
        }

        this.onStatePropertyChanged('show', show => {
            this.panelContainer.setState({
                isShown: show
            })
        })
    }

    afterRender() {
        this.panelContainer = new PanelContainer({
            component: this.params.hierarchyAssignmentsEditor,
            additionalClass: `userManagement_slidingPanel ${this.params.extraClass}`,
            showAnimationClass: "anim-show-slide-left",
            hideAnimationClass: "anim-hide-slide-left",
            showHideButton: true,
            hideOnEsc: true,
            hideOnClickOutside: {
                hideOnClick: true,
                panelType: this.params.panelType,
            },
            onShowCallback: () => {
                this.params.hierarchyAssignmentsEditor.show()
            },
            onHideCallback: () => {
                this.params.hierarchyAssignmentsEditor.hide()
            },
            onClickContentCallback: this.params.onClickContent,
            hideHandler: () => this.actions.closeEditor(),
            onClickCloseButton: () => this.actions.closeAllPanels(),
        }).init(this.$containerEl)
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/components/hierarchyAssignmentsEditor/HierarchyAssignmentsEditorPanel.js